import { useContext } from 'react';
import { RouteConfigContext, RouteConfigContextType } from '@/context/RouteConfigContext';

/**
 * Hook to access the basePath context
 * @returns The RouteConfigContext object containing basePath
 */
export const useBasePath = (): RouteConfigContextType => {
  const context = useContext(RouteConfigContext);
  if (context === undefined) {
    throw new Error('useBasePath must be used within a RouteConfigProvider');
  }
  return context;
};
